import { render, staticRenderFns } from "./Formations.vue?vue&type=template&id=6ecd3e8f&scoped=true"
import script from "./Formations.vue?vue&type=script&lang=js"
export * from "./Formations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecd3e8f",
  null
  
)

export default component.exports